var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v2-product-detail-content',{attrs:{"presentation":"page","product-id":_vm.$route.params.id,"collection-id":_vm.$route.params.collectionId,"wishlist-id":_vm.$route.params.wishlistId}})}
var staticRenderFns = []

export { render, staticRenderFns }